import React, { useMemo } from 'react'
import Box from '@mui/material/Box'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs from 'dayjs'
import { useController } from 'react-hook-form'
import ErrorMessage from '../../ErrorMessage'
import PopOverInfo from '../../PopOverInfo'
import { FieldType } from '../../utils/fieldTypeEnum'
import usePropStyles from '../../utils/usePropStyles'
import { TimePickerProps } from './types'
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers'
import Time from '@tdcerhverv/parrotfish/dist/icons/Icons/Time.svg'

export const TimeInput: React.FC<TimePickerProps> = ({
  fieldType,
  fieldWidth,
  popover,
  control,
  disabled,
  assistiveText,
  minTime,
  maxTime,
  required,
  ...props
}) => {
  if (fieldType !== FieldType.TIMEPICKER) {
    throw Error(`Timepicker field expected fieldtype of TIMEPICKER, instead got ${fieldType}`)
  }
  const fieldName = props.name!
  const { field, fieldState } = useController({ name: fieldName, control, rules: { required: required! } })
  const hasError = Boolean(fieldState.error)
  const propStyles = usePropStyles(fieldWidth)

  const styles = useMemo(
    () => ({
      inputField: {
        display: 'flex',
        '& > div': {
          '& > input, > textArea ': {
            minWidth: 0,
          },
        },
      },
    }),
    [],
  )

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={[propStyles, { pb: 3 }]}>
        <TimePicker
          {...props}
          {...field}
          minTime={minTime && dayjs(minTime)}
          maxTime={maxTime && dayjs(maxTime)}
          format="HH:mm"
          disabled={disabled!}
          ampmInClock={false}
          slots={{
            openPickerIcon: Time,
          }}
          sx={[styles.inputField]}
          slotProps={{
            textField: {
              helperText: (
                <>
                  {hasError ? (
                    <ErrorMessage>
                      <>{fieldState.error?.message}</>
                    </ErrorMessage>
                  ) : (
                    assistiveText
                  )}
                </>
              ),
            },
          }}
          viewRenderers={{
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
            seconds: renderTimeViewClock,
          }}
        />
        {popover && <PopOverInfo {...popover} />}
      </Box>
    </LocalizationProvider>
  )
}
